import React from "react";
import AppButton from "./AppButton";
import { cn } from "@/lib/utils";
import { gtLayer } from "@/hooks/use-gt-layer";
/**
 * Props for the CtaVersion component.
 * @interface CtaVersionProps
 */
interface CtaVersionProps {
  /** Background color class for the button */
  background?: string;
  /** Label text for the CTA button */
  ctaLabel: string;
  /** URL or path for the CTA button link */
  ctaLink: string;
  /** Background color class for the button on hover */
  hoverBackground?: string;
  /** Visual style intent for the button */
  intent?: "primary" | "secondary" | "ghost" | "primarySmall" | "secondarySmall";
  /** Text color class for the button */
  textColor?: string;
  /** Additional CSS classes to apply to the button */
  className?: string;
  /** Whether the button should be full length */
  fullLength?: boolean;

  gtmEvent?: boolean;

  internalLabel?: string;
}

/**
 * CtaVersion component for rendering a customizable CTA button.
 *
 * @param {CtaVersionProps} props - The props for the CtaVersion component
 * @returns {React.ReactElement} A rendered CTA button
 */
const CtaVersion: React.FC<CtaVersionProps> = ({
  background,
  ctaLabel,
  ctaLink,
  hoverBackground,
  internalLabel,
  intent,
  textColor,
  className,
  fullLength,
  gtmEvent = false,
}) => {
  const buttonClasses = cn(
    textColor && `text-${textColor}`,
    background && `bg-${background}`,
    hoverBackground && `hover:bg-${hoverBackground}`,
    className
  );

  const { mainCtaMenuDataLayer } = gtLayer();

  const normalizedLabel = internalLabel?.toLowerCase().replace(/\s/g, "");

  let customActionType: string | undefined;

  if (normalizedLabel?.includes("pai")) {
    customActionType = "pay_invoice";
  } else if (normalizedLabel?.includes("raq")) {
    customActionType = "request_quote";
  } else if (normalizedLabel?.includes("ras")) {
    customActionType = "request_support";
  }

  return (
    <AppButton
      label={ctaLabel}
      link={ctaLink}
      intent={intent}
      className={buttonClasses}
      fullLength={fullLength}
      {...(gtmEvent && {
        onClick: () => {
          mainCtaMenuDataLayer(customActionType ? customActionType : "");
        },
      })}
    />
  );
};

export default CtaVersion;
